import { render, staticRenderFns } from "./DetailCarte.vue?vue&type=template&id=12810f73&"
import script from "./DetailCarte.js?vue&type=script&lang=js&"
export * from "./DetailCarte.js?vue&type=script&lang=js&"
import style0 from "./DetailCarte.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports